import React from 'react';

import { Skeleton } from '@components/main-components/skeleton/Skeleton';

export const ProfileTopSectionSkeleton = () => {
  return (
    <Skeleton className="align-center relative flex h-[100px] w-full items-center overflow-hidden rounded-lg px-4 md:h-40" />
  );
};
